import { render, staticRenderFns } from "./DomainsEdit.vue?vue&type=template&id=00908eb1"
import script from "./DomainsEdit.vue?vue&type=script&lang=js"
export * from "./DomainsEdit.vue?vue&type=script&lang=js"
import style0 from "./DomainsEdit.vue?vue&type=style&index=0&id=00908eb1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports